import { useGetPackageOffersAndFlightOptions } from '../useGetPackageOffersAndFlightOptions';

export const useFlightOptions = () => {
  const { data, error, isValidSearchQuery } =
    useGetPackageOffersAndFlightOptions();

  const isLoading = !data && !error && !!isValidSearchQuery;

  return {
    flightOptions: data?.flightOptions,
    totalFlightOptions: data?.totalFlightOptions,
    isLoading,
  };
};
